/* global MEDIA_ROOT */

import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { eventFullPropTypeShape } from '../../proptypes';

import EventLogo from '../EventLogo';
import StarRating from '../StarRating';

import {
  details,
  link,
  logo as logoStyle,
  priceRange,
  result,
  resultContainer,
  secondaryDetails,
  title as titleStyle,
} from './styles.module.css';

/**
 * Event Info presentational component.
 **/
const EventInfo = ({
  id,
  location,
  logo,
  races,
  permalink,
  startDate,
  startDateFormatted,
  title,
  reviews,
  onSelect,
}) => (
  <div className={resultContainer} key={id}>
    <div className={result}>
      <div className={logoStyle}>
        <EventLogo logo={logo && logo.thumbnail} small />
      </div>
      <div className={details}>
        <div className={titleStyle}>{title}</div>
        <div>
          {startDate &&
          <time dateTime={startDate}> {startDateFormatted}</time>}
          <span> - {location.address.join(', ')}</span>
        </div>
      </div>
      <div className={secondaryDetails}>
        {races && races.pricesFromFormatted &&
          <div className={priceRange}>
            {races.pricesFromFormatted}{races.pricesToFormatted &&
              <span>–{races.pricesToFormatted}</span>}
          </div>}
        <div>
          {reviews && <StarRating value={reviews.ratings.overall} small />}
        </div>
      </div>
    </div>
    <Link to={`${permalink}#source=header_search`} className={link} onClick={onSelect} />
  </div>
);

export default EventInfo;


EventInfo.propTypes = {
  /*
   * Numeric ID of the event.
   */
  id: eventFullPropTypeShape.id, // eslint-disable-line react/require-default-props
  /*
   * Object containing event latlng location and address.
   */
  location: eventFullPropTypeShape.location,
  /*
   * Object containing event logo shape.
   */
  logo: PropTypes.shape(),
  /*
   * Array of race objects.
   */
  races: eventFullPropTypeShape.races,
  /*
   * String permalink to the event page.
   */
  permalink: eventFullPropTypeShape.permalink,
  /*
   * String ISO timestamp of event start date.
   */
  startDate: eventFullPropTypeShape.startDate,
  /*
   * Formatted string of race start date.
   */
  startDateFormatted: eventFullPropTypeShape.startDateFormatted,
  /*
   * String title of the event.
   */
  title: eventFullPropTypeShape.title, // eslint-disable-line react/require-default-props
  /*
   * Object containing reviews.
   */
  reviews: eventFullPropTypeShape.reviews,
  /*
   * Callback function called when event is selected.
   */
  onSelect: PropTypes.func,
};

EventInfo.defaultProps = {
  location: undefined,
  logo: {
    thumbnail: `${MEDIA_ROOT}/images/placeholder-200x200.png`,
  },
  races: undefined,
  permalink: undefined,
  startDate: undefined,
  startDateFormatted: undefined,
  reviews: undefined,
  onSelect: () => {},
};



// WEBPACK FOOTER //
// ./app/src/components/EventInfo/index.jsx